export enum DriveItemListSearchFieldDisplayType {
	Mobile = 'Mobile',
	Desktop = 'Desktop'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/Search/Field/constants.ts